import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import UserAvatar from '../../../../components/UserAvatar';
import dataModel from '../../../../models/DataModel';
import './NewBuildCard.scss';
import Input from '../../../../components/Input';

// Templates Build Card
export class NewBuildCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { editBuild: { name: '', user_build_assignments: [] } };
  }

  componentDidMount() {
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleNameChanged(e) {
    if (!this.state.editBuild.name && !e.target.value) {
      return;
    }
    let editedBuild = Object.assign({}, this.state.editBuild, { name: e.target.value });
    this.setState({ editBuild: editedBuild, nameChanged: e.target.value && e.target.value != '' });
  }

  handleClick(e){
    const { handleNewCardSelected } = this.props;
    if (handleNewCardSelected){
      handleNewCardSelected(this.props.selected ? false : true);
    }
  }

  handleCreateBuild(){
    const { handleCreate, parent } = this.props;
    if (!this.state.editBuild.name) {
      this.props.dataModel.displayWarnErrorMessage('Please supply a name for this build.',
        4000, 2);
    }
    else if (this.state.editBuild && this.state.editBuild.name) {
      if (handleCreate && parent) {
        handleCreate(this.state.editBuild, parent);
      }
      this.handleClearBuild();
    }
  }

  handleClearBuild(){
    this.setState({ editBuild: { name: '', user_build_assignments: [] }, nameChanged: false, userAssignmentsChanged: false  });
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleCreateBuild();
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClearBuild();
    }
  }

  createNotifyMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-build-crud' + type + user.id} key={'user-avatar-build-crud' + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  }

  makeUserAssigments(type, multipleSelections, selectedOption) {
    const editedBuild = Object.assign({}, this.state.editBuild);

    let user_build_assignment = editedBuild.user_build_assignments.filter(bUser => {
      return bUser.user_id == selectedOption.user.id || (bUser.user && bUser.user.id == selectedOption.user.id);
    });
    if (selectedOption.selected) {
      // See if there was already a user of that type

      if (user_build_assignment.length == 0) {
        editedBuild.user_build_assignments.push({ assignment_type: type, user: selectedOption.user, toBeAdded: true });
      }
      else {
        user_build_assignment[0].assignment_type = type;
        user_build_assignment[0].toBeAdded = true;
      }
    }
    else {
      if (user_build_assignment[0].id) {
        user_build_assignment[0].toBeDeleted = true;
      }
      else {
        const index = editedBuild.user_build_assignments.indexOf(user_build_assignment[0]);
        if (index >= 0) {
          editedBuild.user_build_assignments.splice(index, 1);
        }
      }
    }
    this.setState({ editBuild: editedBuild, userAssignmentsChanged: editedBuild.user_build_assignments.length > 0 });
  }

  handleNotifyMultipleSelection(multipleSelections, selectedOption) {
    this.makeUserAssigments('notify', multipleSelections, selectedOption);
  }

  render() {
    const { left, top, width, height } = this.props;
    let style = {
      left: left + 'px', top: top + 'px', width: width + 'px',
      height: height + 'px',
    };

    let connector = <hr className={this.props.connectorClass}/>;

    const disabled = !(this.state.nameChanged || this.state.userAssignmentsChanged);

    let notificationSelector = null;
    style.position = 'absolute';
    
    let saveButton = <div className={'save-button' + (disabled ? ' disabled' : '')} onClick={!disabled ? this.handleCreateBuild : null}>{this.textMap.save.toUpperCase()}</div>;
    let cancelButton = <div className={'cancel-button' + (disabled ? ' disabled' : '')} onClick={!disabled ? this.handleClearBuild : null}>{this.textMap.cancel.toUpperCase()}</div>;
    const action = <div className='actions'>
      {cancelButton}
      {saveButton}
    </div>;

    return (
      <div id={this.props.id} className='new-card-container' style={style} onClick={this.handleClick} >
        {connector}
        <div className="entry-field">
          <div className="card-caption field">
            <Input className="input-field build-title-input" value={this.state.editBuild.name} onChange={this.handleNameChanged} onKeyDown={this.handleKeyDown} 
              ref={(element) => {
                this.titleInput = element;
              }} placeholder="Build Name" />
          </div>
        </div>
        {notificationSelector}
        {action}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.new_users.users,
    dataModel: dataModel,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NewBuildCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTemplateHierarchy/NewBuildCard/index.js